import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import {
  Dropdown,
  Form,
  FormDropdown,
  Header,
  Input,
  Label,
  Segment,
} from 'semantic-ui-react';
import CleanableDatepicker from 'common/components/CleanableDatepicker';
import Timepicker from 'common/components/Timepicker';
import { getTimeUnits, getWorkers } from '../reducers/requirements';
import { fetchRequirements } from '../actions/requirements';
import {
  getPlanningDate,
  getPlanningTime,
  getPreplanningDate,
  getPrimaryWorkerId,
  getSecondaryWorkerIds,
  getVisitDuration,
  getVisitDurationUnit,
} from '../reducers/form';
import {
  updateDuration,
  updateDurationUnit,
  updatePlanningDate,
  updatePlanningTime,
  updatePreplanningDate,
  updateSecondaryWorkerIds,
  updateWorkerId,
} from '../actions/form';
import PreplannificationInput from 'saas/aast/common/components/PreplannificationInput';
import WorkerDropdown from '../../../common/components/WorkerDropdown';
import { fetchFormIfNeeded } from '../../step2/actions/form';
import moment from 'moment';
import { DATE_FORMAT } from 'common/components/PreplanificationSelection';

const mapStateToProps = (state, ownProps) => ({
  timeUnits: getTimeUnits(state),
  workers: getWorkers(state),
  visitDuration: getVisitDuration(state),
  visitDurationUnit: getVisitDurationUnit(state),
  planningDate: getPlanningDate(state),
  planningTime: getPlanningTime(state),
  preplanningDate: getPreplanningDate(state),
  workerId: getPrimaryWorkerId(state),
  secondaryWorkerIds: getSecondaryWorkerIds(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchRequirements: () => dispatch(fetchRequirements(ownProps.id)),
  fetchForm: () => dispatch(fetchFormIfNeeded(ownProps.id)),
  updatePlanningDate: date => dispatch(updatePlanningDate(date)),
  updatePlanningTime: time => dispatch(updatePlanningTime(time)),
  updateVisitDuration: duration => dispatch(updateDuration(duration)),
  updateVisitDurationUnit: unit => dispatch(updateDurationUnit(unit)),
  updatePreplanningDate: date => dispatch(updatePreplanningDate(date)),
  updateWorkerId: id => dispatch(updateWorkerId(id)),
  updateSecondaryWorkerIds: ids => dispatch(updateSecondaryWorkerIds(ids)),
});

export class Page extends React.Component {
  constructor(props) {
    super(props);

    this._renderPrimaryWorkersOptions = this._renderPrimaryWorkersOptions.bind(
      this
    );
  }

  componentWillMount() {
    this.props.fetchRequirements();
    this.props.fetchForm();
  }

  _renderPrimaryWorkersOptions() {
    return this.props.workers.map(w => ({
      key: w.id,
      text: w.display_name,
      value: w.id,
    }));
  }

  _renderSecondaryWorkersOptions() {
    return this.props.workers
      .filter(
        w => this.props.workerId === undefined || this.props.workers !== w.id
      )
      .map(w => ({
        key: w.id,
        text: w.display_name,
        value: w.id,
      }));
  }

  render() {
    const {
      timeUnits,
      visitDuration,
      visitDurationUnit,
      planningDate,
      planningTime,
      preplanningDate,
      workerId,
      secondaryWorkerIds,
    } = this.props;

    console.log(`planningDate : ${planningDate}`);

    const parsedDate = () => {
      if (planningDate && planningDate.includes('/')) {
        return moment(planningDate, DATE_FORMAT).format(DATE_FORMAT);
      } else if (planningDate) {
        return moment(planningDate, 'YYYY-MM-DD').format(DATE_FORMAT);
      } else {
        return planningDate;
      }
    };

    console.log(`parsedDate : ${parsedDate()}`);

    return (
      <Form>
        <Segment>
          <Header as="h3">Planifier la visite</Header>
          <Form.Group>
            <Form.Field width={9}>
              <label>Date ou semaine</label>
              <Form.Group>
                <Form.Field width={6}>
                  <CleanableDatepicker
                    identifier="date"
                    name="planningDate"
                    value={parsedDate() || ''}
                    onChange={this.props.updatePlanningDate}
                    placeholder="JJ/MM/AAAA"
                  />
                </Form.Field>
                <Form.Field width={3}>
                  <Timepicker
                    name="planningTime"
                    value={planningTime || ''}
                    onChange={this.props.updatePlanningTime}
                  />
                </Form.Field>
                <Form.Field width={1} style={{ paddingTop: '7px' }}>
                  <Label circular color="grey">
                    ou
                  </Label>
                </Form.Field>
                <Form.Field width={8}>
                  <PreplannificationInput
                    name="preplanningDate"
                    value={preplanningDate || ''}
                    onChange={this.props.updatePreplanningDate}
                    placeholder="Semaine"
                  />
                </Form.Field>
              </Form.Group>
            </Form.Field>
            <Form.Field width={7}>
              <label>Durée de l'intervention</label>
              <Input
                value={visitDuration || ''}
                type="number"
                label={
                  <Dropdown
                    value={visitDurationUnit || 107}
                    options={timeUnits.map(tu => ({
                      key: tu.id,
                      text: tu.label,
                      value: tu.id,
                    }))}
                    basic
                    onChange={(_, value) =>
                      this.props.updateVisitDurationUnit(value.value)
                    }
                  />
                }
                labelPosition="right"
                placeholder="Durée"
                onChange={(_, value) =>
                  this.props.updateVisitDuration(parseInt(value.value, 0))
                }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <WorkerDropdown
              workerId={workerId}
              workers={this.props.workers}
              onChange={id => {
                if (id) this.props.updateWorkerId(parseInt(id, 0));
                else {
                  this.props.updateWorkerId(id);
                }
              }}
              canDelete
            />
            <FormDropdown
              label="Techniciens secondaires"
              selection
              multiple
              options={this._renderSecondaryWorkersOptions()}
              value={secondaryWorkerIds}
              onChange={(_, value) =>
                this.props.updateSecondaryWorkerIds(value.value)
              }
              width={11}
            />
          </Form.Group>
        </Segment>
      </Form>
    );
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  timeUnits: PropTypes.array.isRequired,
  fetchRequirements: PropTypes.func.isRequired,
  updatePlanningDate: PropTypes.func.isRequired,
  updatePlanningTime: PropTypes.func.isRequired,
  updateVisitDuration: PropTypes.func.isRequired,
  updateVisitDurationUnit: PropTypes.func.isRequired,
  updatePreplanningDate: PropTypes.func.isRequired,
  updateWorkerId: PropTypes.func.isRequired,
  updateSecondaryWorkerIds: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step2/components/Page.js